<div class="header">
    <button mat-mini-fab color="primary" (click)="toggle()">
        <mat-icon *ngIf="!hidden">visibility_off</mat-icon>
        <mat-icon *ngIf="hidden">visibility</mat-icon>
    </button>
    <h2>Pitch</h2>
</div>
<markdown class="md" *ngIf="!hidden">{{widget?.textMarkdown}}</markdown>
